<template>
  <div class="wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>微信小程序接入</span>
        </div>
      </h3>
    </el-header>
    <el-row>
      <el-form inline size="small">
        <el-radio-group v-model="type">
          <el-radio label="1">微信小程序授权</el-radio>
          <el-radio label="0">微信小程序秘钥接入</el-radio>
        </el-radio-group>
        <div>
          <el-button
            type="info"
            icon="el-icon-plus"
            style="margin-bottom: 10px;"
            size="small"
            @click="createCodeAuthorize()"
          >添加</el-button>
        </div>
      </el-form>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <el-table :data="list" size="small" style="width: 100%">
      <el-table-column prop="name" label="小程序名称" align="center"></el-table-column>
      <el-table-column prop="routeStrategyName" label="路由策略" align="center"></el-table-column>
      <!-- <el-table-column prop="bot" label="客服机器人" align="center"></el-table-column> -->
      <el-table-column prop="type" label="接入类型" align="center" :formatter='formatType'></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template v-slot="scope">
          <el-tooltip class="item" effect="light" content="修改" placement="bottom">
          <el-button
            type="text"
            size="small"
            @click="editItem(scope)"
          >
            <svg class="icon icon-bianji" aria-hidden="true">
              <use xlink:href="#icontable-bianji" />
            </svg>
          </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="删除" placement="bottom">
          <el-button
            type="text"
            @click="deleteItem(scope)"
            size="small"
          >
            <svg class="icon icon-delete" aria-hidden="true">
              <use xlink:href="#icontable-delete" />
            </svg>
          </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="float:right;">
      <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :page-size.sync="form.limit"
      :current-page.sync="form.page"
      :total="form.total"
      @current-change="handleCurrentChange"
    ></el-pagination>
    </el-row>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'WxappList',
  data() {
    return {
      type: '1',
      modeFlag: true,
      list: [],
      form: {
        page: 1,
        limit: 10,
        total: 0
      },
      url: ''
    }
  },
  props: {
    wxappListFlag: Boolean
  },
  mounted() {
    this.getList()
  },
  computed: {
  },
  methods: {
    getList() {
      var that = this
      const params = {
        channelId: 'miniprogram',
        page: this.form.page,
        limit: this.form.limit
      }

      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/list', { params }).then(res => {
        if (res.data.code === 2000) {
          that.list = res.data.data.list
          that.form.total = res.data.data.total
        }
      })
    },
    formatType(row, column, cellValue, index) {
      var type = cellValue
      return type === 0 ? '秘钥接入' : '授权接入'
    },
    handleCurrentChange(page) {
      this.form.page = page
      this.getList()
    },
    createCodeAuthorize () {
      if (this.type === '0') {
        this.$emit('changeView', 2)
      } else {
        this.gotoAuthCodeUrl()
      }
    },
    gotoAuthCodeUrl() {
      const params = {}
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/getAuthorizeUrl', { params }).then(res => {
        if (res.data.code === 2000) {
          const result = res.data.data
          window.location.href = result.replace('{redirectUri}', encodeURIComponent('http://jcyf8198.demo.xiaoi.net/#/channel/weixinapp/'))
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editItem(scope) {
      if (scope.row.type === '0' || scope.row.type === 0) {
        this.$emit('changeView', 2, scope.row)
      } else {
        this.$emit('changeView', 1, scope.row)
      }
    },
    deleteItem(scope) {
      this.$confirm('删除后将无法撤销，您是否要删除该内容？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.delItem(scope)
      })
    },
    delItem(scope) {
      const params = {
        id: scope.row.id
      }
      const that = this
      this.$http.delete(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/delete', { params }).then(function(response) {
        if (response.data.code === 2000) {
          that.$message.success('删除成功！')
          that.getList()
        } else if (response.data.code === 2001) {
          that.$message.error(response.data.msg)
        }
      }).catch(function(error) {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 60px - 42px);
}
.el-header {
  /*height: auto !important;*/
  margin-bottom: 0;
  padding: 0;
  .title {
    /*margin-bottom: 20px;*/
  }
}
.el-form {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    margin-bottom: 10px;
  }
  .el-button {
  }
}

</style>
